import { useEffect, useState } from "react";
import Moment from "react-moment";
import { API, endpoints } from "../api";
import { Error } from "../components";
import { useAuth } from "../context/Auth";
import { toastType } from "../utils/strings";
import { errorToString } from "../utils/utils";
import Content from "../components/content";
import { ImageModal } from "../components/image-modal";
import { Link } from "react-router-dom";
import moment from "moment";

const Events = () => {
  const {
    showToast,
    showGlobalLoader: setLoading,
    globalLoader: loading,
  } = useAuth();
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);
  /** "" = all events, "free" / "paid" filter via the event_type param */
  const [eventType, setEventType] = useState("");

  const getData = () => {
    setLoading(true);
    API.get({
      route: `${endpoints.EVENT}?all=1${eventType ? `&event_type=${eventType}` : ""}`,
    })
      .then((data) => {
        setEvents(data?.result);
      })
      .catch((data) => {
        showToast({
          text: errorToString(data?.response),
          type: toastType.ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });
  };

  useEffect(() => {
    getData();
  }, [eventType]);

  return <Content
    title={
      <div className="all-entries">
         <Link to="/enter-new-event" className="fw-600 text-white cursor-pointer bg-blue-img all-entries-btn">
          <span className="all-entries-btn__label">
            Enrol in Open Event
            <small className="hidden-sm">No membership required</small>
          </span>
          <i className="fa-regular fa-hand-back-point-up"></i>
        </Link>
        <Link to="/enter-new-event" className="fw-600 text-white cursor-pointer bg-blue-img all-entries-btn">
          <span>Click to Enter</span>
          <i className="fa-regular fa-hand-back-point-up"></i>
        </Link>
      </div>
    }
    // icon="fa-solid fa-info"
    loading={loading}
  >
    <div className="event-type-filter mb-3">
      {[
        { label: "All Events", value: "" },
        { label: "Free Events", value: "free" },
        { label: "Paid Events", value: "paid" },
      ].map(({ label, value }) => (
        <button
          key={label}
          type="button"
          className={`fw-600 font-xsss cursor-pointer event-type-filter__btn${eventType === value ? " active" : ""}`}
          onClick={() => setEventType(value)}
        >
          {label}
        </button>
      ))}
    </div>
    {events?.length ? <table className="custom-table">
      <tr>
        <th>Event</th>
        <th className="hidden-sm text-center">Start Date</th>
        <th className="text-center">Poster</th>
        <th className="text-center">
          <span className="hidden-sm">Information PDF</span>
          <span className="show-sm">Info</span>
        </th>
        <th></th>

      </tr>
      {events?.map(
        ({ eventTitle, startTime, entriesCloseTime, posterFileSize, posterFile, posterImage }) => {

          var compareDate = moment(new Date()).format("YYYY-MM-DD");
          const isEnterDatePassed = moment(compareDate).isAfter(entriesCloseTime);
          return (
            <tr>
              <td>{eventTitle}
                <br />
                <div className="show-sm">
                  (<Moment format="DD MMM YYYY">{startTime}</Moment>)
                </div>
              </td>
              <td className="hidden-sm text-center">
                <Moment format="DD MMM YYYY">{startTime}</Moment>
                {/* <Moment format="DD MMM YYYY">{entriesCloseTime}</Moment> */}
              </td>
              <td className="text-center">
                {posterImage ? (
                  <ImageModal
                    img={posterImage}
                    btn={
                      <a
                        href="jsavascript:void(0)"
                      // className="d-block bg-gray rounded-xl text-center text-black px-2 py-1 font-xsss w100"
                      >
                        <i className="fa fa-download" />
                      </a>
                    }
                  />
                ) : <span>Pending</span>}
              </td>
              <td className="text-center">
                {posterFile ? (
                  <a
                    href={posterFile}
                    target="_blank"
                    download
                  >
                    <i className="fa fa-download" />
                  </a>
                ) : "Pending"}
              </td>
              <th>
                {isEnterDatePassed ? <a className="d-block rounded-xl text-center text-white px-2 py-1 font-xsss w100 bg-mini-gradiant shadow-sm" >Closed</a> : <Link to="/enter-new-event">
                  <a className="d-block rounded-xl text-center text-white px-2 py-1 font-xsss w100 shadow-sm" style={{ backgroundColor: '#00af4f' }}>Open</a>
                </Link>}
              </th>
            </tr>
          )
        }
      )}
    </table> : null}
    {!events?.length && !loading && loaded ? <p className="font-xs">No Data to show</p> : null}
  </Content>
};

export default Events;
